// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d0ecb54f","488":"571d1e81"}[chunkId] + ".chunk.js";
};